import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit';
import _ from 'lodash';

import apiInstance from '../../common/apis/index';
import { ProcessedOcr } from '../../florence/types/ProcessedOcr';
import florenceApi from '../apis/FlorenceApi';
import { CurrentUser } from '../types/User';

type Model = {
  loading: boolean;
  filterInclude: string[];
  filterExclude: string[];
  user: CurrentUser | null;
  processedOcrs: ProcessedOcr[];
};

export const initialState: Model = {
  loading: true,
  filterInclude: [],
  filterExclude: [],
  user: null,
  processedOcrs: [],
};

const modelSlice = createSlice({
  initialState,
  name: 'model',
  reducers: {
    setFilterInclude: (state, action: PayloadAction<string[]>) => {
      state.filterInclude = action.payload;
    },
    setFilterExclude: (state, action: PayloadAction<string[]>) => {
      state.filterExclude = action.payload;
    },
    clearAllFilters: (state) => {
      state.filterExclude = [];
      state.filterInclude = [];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setUser: (state, action: PayloadAction<CurrentUser>) => {
      state.user = action.payload;
    },
    updateOcr: (state, action: PayloadAction<ProcessedOcr>) => {
      const index = state.processedOcrs.findIndex(
        (o) => o.id === action.payload.id
      );
      if (index !== -1) {
        state.processedOcrs[index] = action.payload;
      }
    },
    addProcessedOcrs: (state, action: PayloadAction<ProcessedOcr[]>) => {
      state.processedOcrs = _.uniqBy(
        [...state.processedOcrs, ...action.payload],
        'id'
      );
    },
    addProcessedOcr: (state, action: PayloadAction<ProcessedOcr>) => {
      state.processedOcrs.push(action.payload);
      state.processedOcrs = _.uniqBy(state.processedOcrs, 'id');
    },
    removeProcessedOcr: (state, action: PayloadAction<ProcessedOcr>) => {
      const index = state.processedOcrs.findIndex(
        (o) => o.id === action.payload.id
      );
      if (index !== -1) state.processedOcrs.splice(index, 1);
    },
    clearProcessedOcrs: (state) => {
      state.processedOcrs = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(apiInstance.util.resetApiState.match, () => {
        return initialState;
      })
      .addMatcher(florenceApi.endpoints.search.matchPending, (state) => {
        state.loading = true;
      })
      .addMatcher(
        isAnyOf(
          florenceApi.endpoints.search.matchFulfilled,
          florenceApi.endpoints.search.matchRejected
        ),
        (state) => {
          state.loading = false;
        }
      );
  },
});

export const {
  setFilterExclude,
  setFilterInclude,
  clearAllFilters,
  setLoading,
  setUser,
  addProcessedOcr,
  clearProcessedOcrs,
  removeProcessedOcr,
  addProcessedOcrs,
  updateOcr,
} = modelSlice.actions;
export default modelSlice;
